module.exports = __webpack_public_path__ + "img/capitalIcon.96c38760.png";